import { Component, OnInit } from '@angular/core';
import { AdminApiService, AdminHomeData } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-home',
    templateUrl: './admin-home.component.html'
})
export class AdminHomeComponent implements OnInit {

    data: AdminHomeData = null as any;

    hero: any = {
        id: 0,
        eyebrow: '',
        title: '',
        description: '',
        primaryText: '',
        primaryUrl: '',
        secondaryText: '',
        secondaryUrl: '',
        status: true
    };

    selectedType = 'metrics';

    itemModel: any = {
        type: 'metrics',
        id: 0,
        value: '',
        label: '',
        no: '',
        tag: '',
        title: '',
        description: '',
        sort: 0,
        status: true
    };

    loading = false;
    saving = false;
    errorMessage = '';
    successMessage = '';

    typeList = [
        { key: 'metrics', name: 'Metrics' },
        { key: 'trustItems', name: 'Trust Items' },
        { key: 'industries', name: 'Industries' },
        { key: 'badges', name: 'Badges' },
        { key: 'cases', name: 'Cases' },
        { key: 'process', name: 'Process' },
        { key: 'features', name: 'Features' }
    ];

    constructor(private adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getAdminHome().subscribe(
            (res: AdminHomeData) => {
                this.data = res;

                if (res.hero) {
                    this.hero = {
                        id: res.hero.id || 0,
                        eyebrow: res.hero.eyebrow || '',
                        title: res.hero.title || '',
                        description: res.hero.description || '',
                        primaryText: res.hero.primaryText || '',
                        primaryUrl: res.hero.primaryUrl || '',
                        secondaryText: res.hero.secondaryText || '',
                        secondaryUrl: res.hero.secondaryUrl || '',
                        status: res.hero.status === null || res.hero.status === undefined ? true : res.hero.status
                    };
                }

                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Home admin data could not be loaded.';
                this.loading = false;
            }
        );
    }

    saveHero(): void {
        this.successMessage = '';
        this.errorMessage = '';
        this.saving = true;

        this.adminApi.saveHomeHero(this.hero).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Home hero saved successfully.';
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Home hero could not be saved.';
            }
        );
    }

    changeType(type: string): void {
        this.selectedType = type;
        this.newItem();
    }

    getItems(): any[] {
        if (!this.data) {
            return [];
        }

        const items = (this.data as any)[this.selectedType];

        return items || [];
    }

    newItem(): void {
        this.itemModel = {
            type: this.selectedType,
            id: 0,
            value: '',
            label: '',
            no: '',
            tag: '',
            title: '',
            description: '',
            sort: 0,
            status: true
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    editItem(item: any): void {
        this.itemModel = {
            type: this.selectedType,
            id: item.id || 0,
            value: item.value || '',
            label: item.label || '',
            no: item.no || '',
            tag: item.tag || '',
            title: item.title || '',
            description: item.description || '',
            sort: item.sort || 0,
            status: item.status === null || item.status === undefined ? true : item.status
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    saveItem(): void {
        this.successMessage = '';
        this.errorMessage = '';

        this.itemModel.type = this.selectedType;

        if (this.selectedType === 'metrics') {
            if (!this.itemModel.value || !this.itemModel.label) {
                this.errorMessage = 'Value and label are required.';
                return;
            }
        } else if (this.selectedType === 'industries' || this.selectedType === 'process') {
            if (!this.itemModel.no || !this.itemModel.title) {
                this.errorMessage = 'No and title are required.';
                return;
            }
        } else if (this.selectedType === 'cases') {
            if (!this.itemModel.tag || !this.itemModel.title) {
                this.errorMessage = 'Tag and title are required.';
                return;
            }
        } else {
            if (!this.itemModel.title) {
                this.errorMessage = 'Title is required.';
                return;
            }
        }

        this.saving = true;

        this.adminApi.saveHomeItem(this.itemModel).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Home item saved successfully.';
                this.newItem();
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Home item could not be saved.';
            }
        );
    }

    deleteItem(item: any): void {
        if (!confirm('Delete this item?')) {
            return;
        }

        this.adminApi.deleteHomeItem(this.selectedType, item.id).subscribe(
            () => {
                this.successMessage = 'Item deleted.';
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Item could not be deleted.';
            }
        );
    }

    isMetrics(): boolean {
        return this.selectedType === 'metrics';
    }

    isNumbered(): boolean {
        return this.selectedType === 'industries' || this.selectedType === 'process';
    }

    isCase(): boolean {
        return this.selectedType === 'cases';
    }
}